import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/common";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Download, FileBarChart } from "lucide-react";
import { toCsv } from "../components/common";
import { toast } from "sonner";

const REPORTS = [
  { key: "brands", label: "Brands", endpoint: "/brands" },
  { key: "outlets", label: "Outlets", endpoint: "/outlets" },
  { key: "assets", label: "Assets", endpoint: "/assets" },
  { key: "manufacturers", label: "Manufacturers", endpoint: "/manufacturers" },
  { key: "subscriptions", label: "Subscriptions", endpoint: "/subscriptions" },
  { key: "invoices", label: "Invoices / Revenue", endpoint: "/invoices" },
  { key: "maintenance", label: "Maintenance", endpoint: "/maintenance" },
  { key: "warranty", label: "Warranty", endpoint: "/warranty" },
];

export default function Reports() {
  const download = async (r) => {
    try {
      const { data } = await api.get(r.endpoint, { params: { limit: 1000 } });
      if (!data.items?.length) { toast.error("No data available"); return; }
      toCsv(data.items, `${r.key}-report.csv`);
      toast.success(`${r.label} report downloaded`);
    } catch { toast.error("Failed to generate report"); }
  };
  return (
    <>
      <PageHeader title="Reports" description="Generate on-demand CSV reports across every module." />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map((r) => (
          <Card key={r.key} className="p-5 rounded-xl border">
            <div className="flex items-start justify-between">
              <div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">Report</div>
                <div className="font-heading text-lg font-medium mt-1">{r.label}</div>
              </div>
              <div className="w-9 h-9 rounded-lg bg-blue-50 text-blue-600 grid place-items-center dark:bg-blue-950/40">
                <FileBarChart className="w-4 h-4" />
              </div>
            </div>
            <Button data-testid={`report-${r.key}-btn`} onClick={() => download(r)} className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white">
              <Download className="w-4 h-4 mr-1" /> Download CSV
            </Button>
          </Card>
        ))}
      </div>
    </>
  );
}
